import React, { FC } from 'react';

import { ScaleLinear, area, curveStepAfter } from 'd3';

import theme from '@src/theme';

import { ChartEntry } from '../../types/types';

import styled from 'styled-components';

const Path = styled.path<{ fill: string | undefined; opacity: number }>`
  opacity: ${({ opacity }) => opacity || 1}}
  stroke: ${({ fill }) => fill ?? theme.accent.a3}
  fill: ${({ fill }) => fill ?? theme.accent.a3}
`;

interface Props {
  series: ChartEntry[];
  xScale: ScaleLinear<number, number>;
  yScale: ScaleLinear<number, number>;
  xValue: (d: ChartEntry) => number;
  yValue: (d: ChartEntry) => number;
  fill?: string | undefined;
  opacity?: number;
}

const Area: FC<Props> = ({
  series,
  xScale,
  yScale,
  xValue,
  yValue,
  fill,
  opacity,
}) => (
  <Path
    opacity={opacity || 1}
    fill={fill}
    d={
      area()
        .curve(curveStepAfter)
        .x((d: unknown) => xScale(xValue(d as ChartEntry)))
        .y1((d: unknown) => yScale(yValue(d as ChartEntry)))
        .y0(yScale(0))(
        series.filter((d) => {
          const value = xScale(xValue(d));
          return value > 0 && value <= window.innerWidth;
        }) as Iterable<[number, number]>,
      ) ?? undefined
    }
  />
);

export default Area;
